<template>
    <v-container v-show="show">
        <v-alert
            v-show="showSuccess"
            :timeout="-1"
            type="success"
            dismissible
            style="border-radius: 10px;"
        >
            <p 
                v-for="(alert, a) in alertsSuccess"
                :key="`ALERT-OK-${a}`"
                style="margin-bottom: 0px;"
            >{{ getAlertMessage(alert) }}</p>
        </v-alert>
        <v-alert
            v-show="showError"
            :timeout="-1"
            type="error"
            dismissible
            style="border-radius: 10px;"
        >
            <p
                v-for="(alert, a) in alertsError"
                :key="`ALERT-ERROR-${a}`"
                style="margin-bottom: 0px;"
            >{{ getAlertMessage(alert) }}</p>
        </v-alert>
    </v-container>
</template>
<script>
export default {
    name: "ResultadoAxios",
    data: () => ({
        alerts: []
    }),
    computed: {
        show() {
            return this.alerts.length > 0;
        },
        alertsSuccess() {
            return this.alerts.filter((a) => !a.erro);
        },
        alertsError() {
            return this.alerts.filter((a) => a.erro);
        },
        showSuccess() {
            return this.alertsSuccess.length > 0;
        },
        showError() {
            return this.alertsError.length > 0;
        }
    },
    methods: {
        getAlertType(alert) {
            return alert.erro ? "error" : "success";
        },
        getAlertMessage(alert) {
            return alert.mensagem;
        },
        showAlerts(results) {
            if (!Array.isArray(results)) {
                this.alerts = [];
                return;
            }
            this.alerts = results
                .map((a) => {
                    const fromRoot = a.mensagem != null && a.mensagem !== '' ? String(a.mensagem) : '';
                    const fromValidation =
                        a.validation && a.validation.message != null ? String(a.validation.message) : '';
                    const text = fromRoot || fromValidation;
                    return {
                        erro: !!a.erro,
                        mensagem: text || (a.erro ? 'Erro' : ''),
                    };
                })
                .filter((x) => x.mensagem !== '');
        }
    }
}
</script>
<style>
    
</style>